import { render, staticRenderFns } from "./documento_cliente.vue?vue&type=template&id=6abe501f&"
import script from "./documento_cliente.vue?vue&type=script&lang=js&"
export * from "./documento_cliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports